document.addEventListener('DOMContentLoaded', function () {
  // Shared limiter: retrieves the max stock from the card
  function getMax(card) {
    return parseInt(card.getAttribute('data-max-quantity') || '0', 10);
  }


  // NEW: toggle note for Nicotine Pouches
  function updateRollNote(card){
    if(!card) return;
    const type = (card.getAttribute('data-type') || '').toLowerCase();
    if(type !== 'nicotine-pouches') return;
    const input = card.querySelector('.quantity-input');
    const note  = card.querySelector('.roll-note');
    if(!input || !note) return;
    const val = parseInt(input.value || '0', 10) || 0;
    note.style.display = val > 0 ? 'block' : 'none';
  }

  // Initializes each Featured Collection section only once
  document.querySelectorAll('.featured-collection').forEach(function (section) {
    if (section.dataset.init === 'true') return;
    section.dataset.init = 'true';

    // Sets the max="" attribute on each input based on data-max-quantity
    section.querySelectorAll('.product-card').forEach(function (card) {
      const max = getMax(card);
      card.querySelectorAll('.quantity-input').forEach(function (input) {
        input.setAttribute('min', '0');
        input.setAttribute('step', '1');
        input.setAttribute('max', String(max));
        input.value = '0';
      });
    });

    // 👉 Initial pass for the note
    section.querySelectorAll('.product-card').forEach(updateRollNote);

    // Plus button
    section.addEventListener('click', function (e) {
      const plus = e.target.closest('.plus-btn');
      if (!plus) return;

      const card  = plus.closest('.product-card');
      const input = card.querySelector('.quantity-input');
      const max   = getMax(card);
      const val   = parseInt(input.value || '0', 10) || 0;

      if (val < max) {
        input.value = String(val + 1);
      } else {
        alert("You have reached the maximum available quantity.");
      }

      updateAddButton(card);
      updateRollNote(card);
    });

    // Minus button
    section.addEventListener('click', function (e) {
      const minus = e.target.closest('.minus-btn');
      if (!minus) return;

      const card  = minus.closest('.product-card');
      const input = card.querySelector('.quantity-input');
      const val   = parseInt(input.value || '0', 10) || 0;

      input.value = String(Math.max(0, val - 1));
      updateAddButton(card);
      updateRollNote(card);
    });

    // Bounded keyboard input (cannot exceed stock)
    section.addEventListener('input', function (e) {
      const input = e.target.closest('.quantity-input');
      if (!input) return;

      const card = input.closest('.product-card');
      const max  = getMax(card);
      let val    = parseInt(input.value || '0', 10);

      if (isNaN(val) || val < 0) val = 0;
      if (val > max) val = max;
      input.value = String(val);
      updateAddButton(card);
      updateRollNote(card);
    });

    // Enable/disable the Add button
    function updateAddButton(card) {
      const input  = card.querySelector('.quantity-input');
      const button = card.querySelector('.add-button');
      const val    = parseInt(input.value || '0', 10) || 0;
      const max    = getMax(card);

      button.disabled = (val <= 0 || val > max);
    }

    // Add to cart (or redirect to product page for bundles)
    section.addEventListener('click', function (e) {
      const btn = e.target.closest('.add-button');
      if (!btn) return;

      const card     = btn.closest('.product-card');

      // ── BUNDLE REDIRECT ──
      const isBundle = String(card.getAttribute('data-is-bundle')).toLowerCase() === 'true';
      if (isBundle) {
        const productUrl = card.getAttribute('data-product-url');
        if (productUrl) { window.location.href = productUrl; return; }
      }

      const variantId= card.getAttribute('data-variant-id');
      const qty      = parseInt(card.querySelector('.quantity-input').value || '0', 10) || 0;
      const max      = getMax(card);

      if (qty <= 0) return;
      if (qty > max) { alert("Quantity exceeds available stock."); return; }

      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';

      // Shopify API: add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(r => { if (!r.ok) throw new Error('Error while adding to cart.'); return r.json(); })
      .then(() => {
        // Visual checkmark
        btn.innerHTML = '<span class="checkmark-icon"><svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M7.5 10l3 3 7-7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
        card.querySelector('.quantity-input').value = '0';
        updateAddButton(card);
        updateRollNote(card);
        if (window.Shopify && typeof Shopify.getCart === 'function') Shopify.getCart();

        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1200);
      })
      .catch(err => {
        alert(err.message || 'Error adding to cart');
        btn.textContent = original;
        btn.disabled = false;
      });
    });
  });
});
